<template lang="pug">
.login
  .no-login(v-if="!isLogin")
    .content
      .no-login_content.color_text_vip_2 未登录
      .no-login_push.color_text_vip_3 解锁学习办公最佳翻译搭档
    .button
      .no-login_button.color_text_vip_0.color_main_vip_1(@click="goToLogin") 去登录
  .haved-login(v-else)
    .user-avatar
      img.img(:src="userInfo.userAvatar")
    .content
      .user-name(:class="isSVip?'color_text_vip_2' : 'color_text_1'") {{'hi, ' + userInfo.userName}}
      .content_push(:class="isSVip?'color_text_vip_3' : 'color_text_3'")
        .trial(v-if="vipInfo.svipTrialing")
          span 已开通免费试用，若未取消将于{{svipTrialExpire}}自动续费超级会员
        .no-trial(v-else)
          p(v-if="!isSVip && !vipInfo.svipExpire") 解锁学习办公最佳翻译搭档
          p(v-if="isSVip") {{svipExpire}}到期
          p(v-if="!isSVip && vipInfo.svipExpire") 有道翻译超级会员已于{{svipExpire}}到期
    .button
      .haved-login_button.color_text_vip_0.color_text_vip_5_border(@click="quit") 退出登录
</template>
<script>
import util from '@/util';

export default {
  name: 'login',
  props: ['isSVip', 'isLogin', 'userInfo', 'vipInfo'],
  data() {
    return {

    };
  },
  computed: {
    svipExpire() {
      if (this.vipInfo.svipExpire) {
        return util.dateFormat('yyyy-MM-dd', new Date(this.vipInfo.svipExpire));
      }
      return '';
    },
    svipTrialExpire() {
      if (this.vipInfo.svipTrialExpire) {
        return util.dateFormat('yyyy.MM.dd', new Date(this.vipInfo.svipTrialExpire));
      }
      return '';
    },
  },
  methods: {
    goToLogin() {
      window.location.href = `https://c.youdao.com/common-login-web/index.html?redirect_url=${encodeURIComponent(window.location.href)}&t=${new Date().getTime()}`;
    },
    quit() {
      const local = encodeURIComponent(window.location.href);
      window.location.href = `https://dict.youdao.com/login/acc/se/reset?product=DICT&samesite=true&ru=${local}`;
    },
  },
};
</script>
<style lang="stylus" scoped>
.no-login
  overflow hidden
  .content
    vertical-align middle
    display inline-block
    .no-login_content
      margin 4px 0 8px
      font-size 16px
    .no-login_push
      font-size 12px
  .button
    display inline-block
    vertical-align middle
    margin 8px 0 0 24px
    cursor pointer
    .no-login_button
      width 78px
      font-size 12px
      height 32px
      border-radius 100px
      line-height 32px
      text-align center
.haved-login
  .user-avatar
    display inline-block
    vertical-align: middle
    width 42px
    height 42px
    border: 0.5px solid rgba(255, 255, 255, 0.1)
    margin-top 8px
    .img
      width 100%
      height 100%
      display block
      border-radius: 50%
  .content
    margin 8px 0 0 12px
    vertical-align: middle
    display: inline-block
    .user-name
      margin-bottom 4px
      font-size 18px
      line-height 21px
      max-width 195px
      overflow hidden
      text-overflow ellipsis
      white-space nowrap
    .content_push
      font-size 12px
  .button
    display inline-block
    vertical-align middle
    margin 8px 0 0 24px
    cursor pointer
    .haved-login_button
      width 78px
      font-size 12px
      height 32px
      border-radius 100px
      font-weight: 500
      line-height 32px
      text-align center
</style>
